import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import LoadingSpinner from '../../../components/Spinner';

function MessageBlock({ message, loading, color = 'greyScale.900' }) {
  return (
    <Box>
      <Text color={color}>
        {message}
      </Text>
      {loading && <LoadingSpinner isInline minHeight="100px" />}
    </Box>
  );
}

MessageBlock.propTypes = {
  message: PropTypes.string,
  loading: PropTypes.bool,
  color: PropTypes.string
};

export default MessageBlock;
